import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import UpdateRates from '../views/Rates-Management/updateRatesForm';
import DeleteProductRates from "./deleteProductRates";
// import AgentService from "../services";
import { Breadcrumb, BreadcrumbItem, Card, CardBody, Button } from "reactstrap";
import { Link } from "react-router-dom";
import httpClient from "../http-client/client";
const columns = [
  {
    Header:"تاریخ",
    accessor: "rate_date", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center"> {moment(props.value).format('DD-MM-YYYY')}</span>
    )
  },
  {
    Header: "شہر",
    accessor: "city_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
 
  {
    Header: "مصنوعات ",
    accessor: "product_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },

  {
    Header: "مصنوعات اقسام",
    accessor: "product_type_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "آغاز ریٹ",
    accessor: "start_rate", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: " اوسط ریٹ",
    accessor: "average_rate", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "اختتامی ریٹ",
    accessor: "end_rate", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "آپریشن ", // Custom header components!
    accessor: "operation",
    Cell: props => (
      <div className="d-flex justify-content-center">{props.value}</div>
    )
  },
 
];

export default class RatesTable extends Component {
  

  state = {
  //  updateUserModal: false,
    rateId: "",
    productrateFordelete:'',
    productrateForUpdate:'',
    updateProductRates: false,
    deleteProductRatess: false,
    data:[],
    rateId: "",
  
  };

  componentDidMount() {
   //  this.getUsers();
  }

   showUpdateModal =  async function(id)  {
  
    await this.setState({rateId: id,productrateForUpdate:id }, () => {
    this.toggle();
    });
    console.log(this.state.rateId)
  };
  
  showUpdateForDeleteModal = id => {
  
    this.setState({rateId: id ,productrateFordelete:id }, () => {
    this.toggleForDelete();
    });
  };
  toggle = () => {
    this.setState(prevState => ({
      updateProductRates: !prevState.updateProductRates
    }));
  };
  toggleForDelete = () => {
    this.setState(prevState => ({
      deleteProductRatess: !prevState.deleteProductRatess
    }));
  };
  getUsers = ()=>{
    this.props.getUsers();
  }
  deletedata = async id => {
    try {
        let { status } = await httpClient.delete(`/products/product-rates/${id}`);
      
      if(status==200){
        this.forceUpdate();
      
this.setState({data:status})
      }
      } catch (error) {
       
      }
  }
  render() {
     let { data } = this.props;
     
     data.forEach(element => {
       let urlid=`/dashboard/updateRates?${(element["rate_id"])}`;
      element["operation"] = (
           <span>
             <Link to={urlid}>
                <Button color="primary" className={"m-1"}>
                  <i className="fas fa-edit"></i>                </Button>
              </Link>
          {/* <Button
            onClick={() => {
              this.showUpdateModal(element["rate_id"]);
            }}
            color="primary"
            className="m-1"
            // disabled={}
          >
            <i className="fas fa-edit"></i>
          </Button> */}
          <Button
            onClick={() => {
              this.showUpdateForDeleteModal(element["rate_id"]);
            }}
            color="primary"
            className="m-1"
            // disabled={}
          >
            <i className="fas fa-trash"></i>
          </Button>
         
        </span>
      );
    });
    // data.forEach(element => {


    //   element["operation"] = (
    //     <span>
    //       <Button
            

    //         onClick={() => {
    //           this.showUpdateModal(element["user_id"]);
    //         }}
    //         color="primary"
    //         className="m-1"
    //         // disabled={}
    //       >
    //         <i className="fas fa-edit"></i>
    //       </Button>
        
    //     </span>
    //   );
    // });

    return (
      <div>
           <div>
          <Card className={"rectangle-border"}>
            <CardBody className={"d-flex justify-content-end"}>
              <Link to="/dashboard/createRates">
                <Button color="primary" className={"rectangle-border "}>
                  <i className="fas fa-handshake"></i> نئی ریٹس بنائیں{" "}
                </Button>
              </Link>
            </CardBody>
          </Card>
        </div>
        <ReactTable
          data={data}
          columns={columns}
          showPaginationTop={true}
          showPaginationBottom={false}
        />
      
      {(this.state.rateId !== "" && this.state.productrateForUpdate!=="") ? (
         
         <UpdateRates            
            rateId={this.state.rateId}
            modal={this.state.updateProductRates}
            toggle={this.toggle}
          />
          
        ) : null}
         {(this.state.rateId !== "" && this.state.productrateFordelete!=="") ? (
          <DeleteProductRates            
            rateId={this.state.rateId}
            modal={this.state.deleteProductRatess}
            toggle={this.toggleForDelete}
           data={data}
          />
          
        ) : null}
      </div>
    );
  }
}
